import script from "./IIcon.vue?vue&type=script&lang=ts"
export * from "./IIcon.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__